import React from "react";

// "<" is escaped so text from the catalogue can never close the script element.
const serialize = (data) => JSON.stringify(data).replace(/</g, "\\u003c");

/** schema.org structured data. Search engines read JSON-LD anywhere in the page. */
export const JsonLd = ({ data }) => (
  <script type="application/ld+json" dangerouslySetInnerHTML={{ __html: serialize(data) }} />
);
